import {
  reportsDataSearchPath,
  reportsJaqiAiPath,
  reportsMetabaseAccountPath,
  reportsMetabaseAccountPersonalisePath,
  reportsMetabaseCampaignPath,
  reportsMetabaseCampaignPersonalisePath,
} from 'app/navigation/paths'

export interface Page {
  name: string
  path: string
}
export const PATH: Record<string, string> = {
  MetabaseAccount: reportsMetabaseAccountPath,
  MetabaseAccountPersonalise: reportsMetabaseAccountPersonalisePath,
  MetabaseCampaign: reportsMetabaseCampaignPath,
  MetabaseCampaignPersonalise: reportsMetabaseCampaignPersonalisePath,
  DataSearch: reportsDataSearchPath,
  JaqiAi: reportsJaqiAiPath,
}

export const PAGES: Page[] = [
  {
    name: 'Account Overview',
    path: PATH.MetabaseAccount,
  },
  {
    name: 'Account Personalise',
    path: PATH.MetabaseAccountPersonalise,
  },
  {
    name: 'Campaign Overview',
    path: PATH.MetabaseCampaign,
  },
  {
    name: 'Campaign Personalise',
    path: PATH.MetabaseCampaignPersonalise,
  },
  {
    name: 'Data Search',
    path: PATH.DataSearch,
  },
  {
    name: 'Jaqi AI',
    path: PATH.JaqiAi,
  },
]

export const DASHBOARD_NAV_ITEMS = [
  {
    key: 'account',
    title: 'Account Overview',
    path: PATH.MetabaseAccount,
    flag: 'showMetabaseLiveboard',
  },
  {
    key: 'campaign',
    title: 'Campaign Overview',
    path: PATH.MetabaseCampaign,
    flag: 'showMetabaseLiveboard',
  },
  {
    key: 'data-search',
    title: 'Data Search',
    path: PATH.DataSearch,
    flag: 'showDataSearch',
  },
  {
    key: 'jaqi',
    title: 'Jaqi AI',
    path: PATH.JaqiAi,
    flag: 'showJaqi',
  },
] as const
